export default function(params) {
  var self = this;

  self.defaults = {
    modalBuilt: false,
    friendlyName: 'Open In Modal',
    template: 'templates/modals/modal-iframe-preview',
  };

  self.config = _.extend({}, self.defaults, params);
  self.friendlyName = self.config.friendlyName;

  self.handler = function(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if(!self.modalBuilt) {
      self.buildModal();
    }

    self.$modal.modal('show');
  };

  self.buildModal = function() {
    self.$modal = $(
      JST[self.config.template]({
        title: 'Preview',
        iframeUrl: self.config.$iframe.prop('src'),
        btn_text: 'Close'
      })
    );

    self.modalBuilt = true;
  };

  return self;
}
